var map = {
	"./dropdown/dropdown.js": 9,
	"./modal/modal.js": 10,
	"./page/page.js": 11,
	"./readmore/readmore.js": 12
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;


//////////////////
// WEBPACK FOOTER
// G:/RABOTA/lekar/dev/source/modules ^[^\_]*\.js
// module id = 8
// module chunks = 0